import { Component, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { NativeAudio } from "@ionic-native/native-audio";

@Component({
  selector: 'app-stopwatch',
  templateUrl: './stopwatch.html'
})
export class StopwatchComponent implements OnDestroy {
  minutes = 3; // Start with 3 minutes
  seconds = 0;
  isRunning = false;
  intervalId: any;

  constructor(
    private cdr: ChangeDetectorRef,
    private audio: NativeAudio
  ) {}

  displayTime(): string {
    var minutes = this.minutes < 10 ? '0' + this.minutes : this.minutes;
    var secs = this.seconds < 10 ? '0' + this.seconds : this.seconds;
    return minutes + ':' + secs;
  }

  startTimer() {
    if (!this.isRunning) {
      this.isRunning = true;
      this.intervalId = setInterval(() => {
        // Countdown logic
        this.seconds--;

        if (this.seconds < 0) {
          this.seconds = 59;
          this.minutes--;
        }

        // Check if timer has reached 0:00
        if (this.minutes <= 0 && this.seconds <= 0) {
          this.minutes = 0;
          this.seconds = 0;
          this.pauseTimer();
          this.onTimerFinished();
          return;
        }

        // Manually trigger change detection
        this.cdr.detectChanges();
      }, 1000);
    }
  }

  pauseTimer() {
    if (this.isRunning) {
      clearInterval(this.intervalId);
      this.isRunning = false;
    }
  }

  resetTimer() {
    this.pauseTimer();
    this.minutes = 3; // Reset to 3 minutes
    this.seconds = 0;
    // Manually trigger change detection
    this.cdr.detectChanges();
  }

  addMinute() {
    this.minutes++;
    // Manually trigger change detection
    this.cdr.detectChanges();
  }

  subtractMinute() {
    if (this.minutes > 0) {
      this.minutes--;
    } else if (this.minutes === 0 && this.seconds > 0) {
      // If we're at 0 minutes but have seconds, don't allow subtraction
      // to prevent going below 0:00
      return;
    }
    // Manually trigger change detection
    this.cdr.detectChanges();
  }

  onTimerFinished() {
    // Play alarm sound
    let id = 'alarm' + new Date().getTime();
    this.audio.preloadSimple(id, 'assets/alarm.mp3').then(() => {
      this.audio.play(id);
    });
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/stopwatch/stopwatch.ts